/* MV Sortiment assets/mv-sortiment.q.js - Agent T-Q - 2026-10-04
 *
 * FAQ-Seite (sections/faq-multi-groups.liquid): Suche und Themen-Chips, sonst nichts.
 *  1. Suche [data-mv-faq-suche]: filtert die Fragen [data-mv-faq-eintrag] im DOM nach Frage- und Antworttext.
 *     Alle Woerter der Eingabe muessen vorkommen; Gross/klein, Akzente, Umlaut-Umschrift (ae/oe/ue, ss) und
 *     Satzzeichen spielen keine Rolle. Kein Fetch, keine Analytics (Suchtexte koennen persoenlich sein).
 *  2. Chips [data-mv-faq-chip]: "alle" oder ein Gruppen-Key; zeigen nur die Gruppe [data-mv-faq-gruppe], der aktive
 *     Chip traegt aria-current="true" (die Basis-CSS fuellt ihn). Ohne JavaScript sind die Chips Sprungmarken.
 *  3. Zaehler [data-mv-faq-anzahl] je Chip: Treffer der aktuellen Suche je Gruppe ("alle" = Summe). Die Zahlen
 *     entstehen nur zur Laufzeit; im Server-HTML stehen keine (Pruefskript Z-01).
 *  4. Status [data-mv-faq-status] (role=status): Trefferzahl, leer ohne Filter; Hinweis [data-mv-faq-leer] bei
 *     null Treffern, [data-mv-faq-zuruecksetzen] hebt Suche und Thema auf. Genau ein Treffer wird aufgeklappt.
 *  5. Ein Link auf #faq-<key>-<n> klappt die Frage auf (beim Laden und bei hashchange).
 *  6. Theme-Editor: shopify:section:load startet die Sektion neu; shopify:block:select klappt die gewaehlte Frage
 *     auf und hebt Filter auf, die sie verbergen.
 * Zustand: Thema im Attribut data-mv-faq-thema der Wurzel [data-mv-faq], Suchtext im Feld selbst.
 * Delegation auf document (input, click, keydown); laedt allein und in beliebiger Reihenfolge als Teil von
 * assets/mv-sortiment.js (_build/konkat.sh). Unter Node (Tests) liefert die Datei nur die reinen Funktionen.
 * Kommentare ASCII; sichtbare Texte als \u-Escapes, damit die Datei unabhaengig vom Zeichensatz bleibt.
 *
 * Erweiterung Agent D2-B - 2026-10-05 (FAQ-System): Dieselben Hooks gelten fuer sections/mv-faq.liquid im
 * Modus "seite" (Datenquelle snippets/mv-faq-daten.liquid, Gruppen-Anker #faq-<gruppe>, Fragen-Anker
 * #faq-<frage>). Der Modus "auszug" hat keine Wurzel [data-mv-faq] und braucht kein Skript.
 * Punkt 5 gilt jetzt fuer jeden Anker #faq-<kennung> (zielAusHash): Verbirgt ein Filter das Ziel (Gruppe oder
 * Frage), hebt das Skript Suche und Thema auf und scrollt hin; eine Frage klappt es auf. So funktionieren auch
 * Links zwischen Antworten und der Link "Alle Fragen und Antworten" der Auszuege bei aktivem Filter.
 *
 * Erweiterung Agent F-2 - 2026-10-07 (FAQ-Uebersicht und Themenseiten, Inhaber 06.10.2026: "Koennen wir den FAQ
 * auch unterteilen?"; Spezifikation _docs/f2-faq-hub.md):
 *  7. Uebersicht [data-mv-faq-hub] (sections/mv-faq.liquid, Modus "hub"): Suche [data-mv-faq-hub-suche] ueber alle
 *     Fragen. Die Fragen stehen fertig gerendert in template[data-mv-faq-hub-daten] (Thema, Frage, Antwort, Link auf
 *     die Themenseite); Treffer werden geklont, zuerst Treffer in der Frage selbst, die Suchwoerter in der Frage
 *     markiert (mark), hoechstens GRENZE, dann [data-mv-faq-hub-mehr] "Alle n Treffer zeigen". Ab zwei Zeichen
 *     verbirgt das Skript die Startbereiche [data-mv-faq-hub-start] (Beliebte Fragen, Themen-Kacheln) und zeigt
 *     [data-mv-faq-hub-treffer]; ohne Suchtext umgekehrt. Suchbegriffe [data-mv-faq-hub-begriff] fuellen die Suche.
 *     Ohne JavaScript bleiben Kacheln und Beliebte Fragen; die Suche ist dann verborgen ([data-mv-faq-hub-suche-box]).
 *  8. ?q=<text> auf der Uebersicht fuellt die Suche beim Laden (Link "In allen Fragen suchen" der Themenseiten).
 *  9. Alte Anker der FAQ-Seite: #faq-<frage> und #faq-<gruppe> leiten beim Laden und bei hashchange per
 *     location.replace auf die Themenseite um (/pages/faq-<gruppe>#faq-<frage>), aber nur, wenn die Seite
 *     veroeffentlicht ist (data-mv-faq-hub-ziel; Liquid prueft pages[...]). Sonst zeigt die Uebersicht eine Frage
 *     als einzelnen, offenen Treffer; ein Gruppen-Anker trifft ohne Skript die Kachel #faq-<gruppe>.
 * 10. Themenseite (Modus "gruppe", Wurzel [data-mv-faq] wie die FAQ-Seite, Punkte 1, 4 und 5 unveraendert): Links
 *     [data-mv-faq-alle] fuehren mit dem Suchtext auf die Uebersicht (?q=). Alle [data-mv-faq-suche-box] werden
 *     sichtbar (Suchfeld und Link "In allen Fragen suchen"). Die wischbare Themen-Reihe [data-mv-faq-themen]
 *     rollt beim Start so, dass das aktuelle Thema (aria-current="page") sichtbar ist (nur waagrecht).
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-07.1';
  var VERZOEGERUNG = 150;
  var GRENZE = 20;
  var MIN_ZEICHEN = 2;

  var TEXT = {
    eine: '1 Frage',
    mehrere: '{n} Fragen',
    keine: 'Keine passende Frage gefunden',
    thema: ' zum Thema „{t}“',
    gefunden: ' gefunden',
    einzeln: 'Die Frage aus Ihrem Link',
    mehr: 'Alle {n} Treffer zeigen'
  };

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  // Vergleichsform: klein, ohne Akzente, Umlaut-Umschrift zusammengefuehrt, nur a-z und 0-9 mit Leerzeichen
  function normalisiere(text) {
    var s = String(text == null ? '' : text).toLowerCase();
    if (typeof s.normalize === 'function') s = s.normalize('NFD');
    return s
      .replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/ae/g, 'a')
      .replace(/oe/g, 'o')
      .replace(/ue/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/^ +| +$/g, '');
  }

  // Suchwoerter der Eingabe (normalisiert, ohne Dubletten)
  function woerter(eingabe) {
    var teile = normalisiere(eingabe).split(' ');
    var aus = [];
    for (var i = 0; i < teile.length; i++) {
      if (teile[i] && aus.indexOf(teile[i]) === -1) aus.push(teile[i]);
    }
    return aus;
  }

  // Passt ein normalisierter Text zu allen Suchwoertern? Ohne Suchwoerter passt alles.
  function passt(heu, suchwoerter) {
    for (var i = 0; i < suchwoerter.length; i++) {
      if (heu.indexOf(suchwoerter[i]) === -1) return false;
    }
    return true;
  }

  // Zaehler am Chip; das Leerzeichen hoert der Screenreader, sichtbar setzt die Chip-Luecke den Abstand
  function zaehlerText(n) {
    return ' (' + n + ')';
  }

  // Anker-Kennung aus location.hash: nur faq-<kleinbuchstaben, ziffern, bindestrich>, sonst ''
  function zielAusHash(hash) {
    var roh = String(hash == null ? '' : hash).replace(/^#/, '');
    if (!roh) return '';
    try { roh = decodeURIComponent(roh); } catch (e) { return ''; }
    return /^faq-[a-z0-9]+(?:-[a-z0-9]+)*$/.test(roh) ? roh : '';
  }

  // Status: ohne Suche und ohne Thema leer, sonst "<n> Fragen[ zum Thema ...][ gefunden]"
  function statusText(n, mitSuche, themaTitel) {
    if (!mitSuche && !themaTitel) return '';
    if (n === 0) return TEXT.keine;
    var s = n === 1 ? TEXT.eine : TEXT.mehrere.replace('{n}', String(n));
    if (themaTitel) s += TEXT.thema.replace('{t}', themaTitel);
    if (mitSuche) s += TEXT.gefunden;
    return s;
  }

  // Sucht die Uebersicht? Erst ab MIN_ZEICHEN Buchstaben oder Ziffern (ein Zeichen traefe fast alles)
  function istSuche(eingabe) {
    return normalisiere(eingabe).replace(/ /g, '').length >= MIN_ZEICHEN;
  }

  // Status der Uebersicht: leer ohne Suche, sonst "<n> Fragen gefunden" bzw. "Keine passende Frage gefunden"
  function hubStatusText(n, aktiv) {
    return aktiv ? statusText(n, true, '') : '';
  }

  // Wert des Parameters q aus location.search ('+' = Leerzeichen; ohne URLSearchParams fuer alte Browser),
  // Leerraum zusammengefasst, hoechstens 100 Zeichen; kaputte Kodierung ergibt ''
  function qAusSuche(search) {
    var s = String(search == null ? '' : search).replace(/^\?/, '');
    if (!s) return '';
    var paare = s.split('&');
    for (var i = 0; i < paare.length; i++) {
      var p = paare[i].split('=');
      if (p[0] !== 'q') continue;
      var wert = p.slice(1).join('=').replace(/\+/g, ' ');
      try { wert = decodeURIComponent(wert); } catch (e) { return ''; }
      return wert.replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, 100);
    }
    return '';
  }

  // Link "In allen Fragen suchen": Basis der Uebersicht ohne Anker und Parameter, dazu ?q=<Suchtext>
  function hubSuchUrl(basis, text) {
    var b = String(basis || '/pages/faq').split('#')[0].split('?')[0] || '/pages/faq';
    var t = String(text == null ? '' : text).replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, 100);
    return t ? b + '?q=' + encodeURIComponent(t) : b;
  }

  function hat(obj, schluessel) {
    return !!obj && Object.prototype.hasOwnProperty.call(obj, schluessel);
  }

  // Ziel eines alten Ankers der FAQ-Seite: #faq-<frage> -> <Themenseite>#faq-<frage>, #faq-<gruppe> -> <Themenseite>.
  // karte = { fragen: { <frage>: <gruppe> }, ziele: { <gruppe>: <url der veroeffentlichten Seite> } }; sonst ''.
  function zielFuerHash(hash, karte) {
    var id = zielAusHash(hash);
    if (!id || !karte) return '';
    var kennung = id.slice(4);
    if (hat(karte.fragen, kennung)) {
      var g = karte.fragen[kennung];
      return hat(karte.ziele, g) && karte.ziele[g] ? String(karte.ziele[g]).split('#')[0] + '#' + id : '';
    }
    if (hat(karte.ziele, kennung) && karte.ziele[kennung]) return String(karte.ziele[kennung]).split('#')[0];
    return '';
  }

  // Suche ueber alle Fragen: eintraege = [{ id, frage, heu }] (heu = normalisierter Suchtext); alle Woerter
  // muessen vorkommen, zuerst die Treffer in der Frage selbst, sonst Reihenfolge der Datenquelle
  function sucheFragen(eintraege, eingabe) {
    if (!istSuche(eingabe)) return [];
    var w = woerter(eingabe);
    var vorne = [];
    var hinten = [];
    for (var i = 0; i < (eintraege || []).length; i++) {
      var e = eintraege[i];
      if (!passt(e.heu, w)) continue;
      if (passt(normalisiere(e.frage), w)) vorne.push(e);
      else hinten.push(e);
    }
    return vorne.concat(hinten);
  }

  // Vergleichsform je Zeichen mit Rueckverweis auf die Quelle (dieselben Schritte wie normalisiere, ohne das
  // Zusammenfassen der Leerzeichen): Grundlage der Markierung
  function zeichenKarte(text) {
    var s = String(text == null ? '' : text);
    var teile = [];
    for (var i = 0; i < s.length; i++) {
      var c = s.charAt(i).toLowerCase();
      if (typeof c.normalize === 'function') c = c.normalize('NFD');
      c = c.replace(/[̀-ͯ]/g, '').replace(/ß/g, 'ss');
      for (var k = 0; k < c.length; k++) {
        var z = c.charAt(k);
        teile.push({ z: /[a-z0-9]/.test(z) ? z : ' ', von: i, bis: i + 1 });
      }
    }
    var paare = ['ae', 'oe', 'ue'];
    for (var p = 0; p < paare.length; p++) {
      var neu = [];
      for (var j = 0; j < teile.length; j++) {
        if (teile[j].z === paare[p].charAt(0) && teile[j + 1] && teile[j + 1].z === paare[p].charAt(1)) {
          neu.push({ z: teile[j].z, von: teile[j].von, bis: teile[j + 1].bis });
          j += 1;
        } else {
          neu.push(teile[j]);
        }
      }
      teile = neu;
    }
    return teile;
  }

  // Abschnitte [text, treffer] eines Textes: Stellen, die ein Suchwort treffen, mit true (Text unveraendert)
  function abschnitte(text, suchwoerter) {
    var s = String(text == null ? '' : text);
    var karte = zeichenKarte(s);
    var n = '';
    for (var i = 0; i < karte.length; i++) n += karte[i].z;
    var markiert = [];
    for (var m = 0; m < s.length; m++) markiert.push(false);
    var liste = suchwoerter || [];
    for (var w = 0; w < liste.length; w++) {
      if (!liste[w]) continue;
      var ab = 0;
      var pos = n.indexOf(liste[w], ab);
      while (pos !== -1) {
        for (var k = pos; k < pos + liste[w].length; k++) {
          for (var q = karte[k].von; q < karte[k].bis; q++) markiert[q] = true;
        }
        ab = pos + liste[w].length;
        pos = n.indexOf(liste[w], ab);
      }
    }
    var aus = [];
    for (var j = 0; j < s.length; j++) {
      var letztes = aus[aus.length - 1];
      if (letztes && letztes[1] === markiert[j]) letztes[0] += s.charAt(j);
      else aus.push([s.charAt(j), markiert[j]]);
    }
    return aus;
  }

  var api = {
    VERSION: VERSION,
    TEXT: TEXT,
    GRENZE: GRENZE,
    MIN_ZEICHEN: MIN_ZEICHEN,
    normalisiere: normalisiere,
    woerter: woerter,
    passt: passt,
    zaehlerText: zaehlerText,
    statusText: statusText,
    zielAusHash: zielAusHash,
    istSuche: istSuche,
    hubStatusText: hubStatusText,
    qAusSuche: qAusSuche,
    hubSuchUrl: hubSuchUrl,
    zielFuerHash: zielFuerHash,
    sucheFragen: sucheFragen,
    abschnitte: abschnitte
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.faq) return;
  MV.faq = api;

  var texte = typeof WeakMap === 'function' ? new WeakMap() : null;
  var zeitgeber = typeof WeakMap === 'function' ? new WeakMap() : null;
  var hubZustaende = typeof WeakMap === 'function' ? new WeakMap() : null;

  function alle(bereich, selektor) {
    return Array.prototype.slice.call(bereich.querySelectorAll(selektor));
  }

  // Suchtext einer Frage (Frage und Antwort), einmal je Element berechnet
  function heuVon(eintrag) {
    var v = texte ? texte.get(eintrag) : eintrag.__mvFaqText;
    if (v === undefined) {
      v = normalisiere(eintrag.textContent);
      if (texte) texte.set(eintrag, v);
      else eintrag.__mvFaqText = v;
    }
    return v;
  }

  function wurzelVon(el) {
    return el && el.closest ? el.closest('[data-mv-faq]') : null;
  }

  function feldVon(wurzel) {
    return wurzel.querySelector('[data-mv-faq-suche]');
  }

  function themaTitel(wurzel, thema) {
    if (thema === 'alle') return '';
    var gruppe = alle(wurzel, '[data-mv-faq-gruppe]').filter(function (g) { return g.getAttribute('data-mv-faq-gruppe') === thema; })[0];
    var titel = gruppe ? gruppe.querySelector('h2, h3') : null;
    return titel ? titel.textContent.replace(/\s+/g, ' ').replace(/^ | $/g, '') : '';
  }

  function setzeText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  // Themenseite: Links in alle Fragen tragen den Suchtext (?q=)
  function alleLinks(wurzel, text) {
    alle(wurzel, '[data-mv-faq-alle]').forEach(function (a) {
      var ziel = hubSuchUrl(a.getAttribute('data-mv-faq-alle'), text);
      if (a.getAttribute('href') !== ziel) a.setAttribute('href', ziel);
    });
  }

  // Filter anwenden: Fragen, Gruppen, Chips, Zaehler, Status, Leer-Hinweis
  function anwenden(wurzel) {
    var feld = feldVon(wurzel);
    var suchwoerter = woerter(feld ? feld.value : '');
    var thema = wurzel.getAttribute('data-mv-faq-thema') || 'alle';
    var zaehler = { alle: 0 };
    var sichtbar = [];

    alle(wurzel, '[data-mv-faq-gruppe]').forEach(function (gruppe) {
      var key = gruppe.getAttribute('data-mv-faq-gruppe');
      var imThema = thema === 'alle' || thema === key;
      var eintraege = alle(gruppe, '[data-mv-faq-eintrag]');
      var inGruppe = 0;
      zaehler[key] = 0;
      eintraege.forEach(function (eintrag) {
        var ok = passt(heuVon(eintrag), suchwoerter);
        if (ok) {
          zaehler[key] += 1;
          zaehler.alle += 1;
        }
        eintrag.hidden = !(ok && imThema);
        if (ok && imThema) {
          inGruppe += 1;
          sichtbar.push(eintrag);
        }
      });
      // Gruppe ohne Fragen (Setting show_empty_groups) nur ohne Suche
      gruppe.hidden = !(imThema && (eintraege.length ? inGruppe > 0 : suchwoerter.length === 0));
    });

    alle(wurzel, '[data-mv-faq-chip]').forEach(function (chip) {
      var key = chip.getAttribute('data-mv-faq-chip');
      if (key === thema) chip.setAttribute('aria-current', 'true');
      else chip.removeAttribute('aria-current');
      setzeText(chip.querySelector('[data-mv-faq-anzahl]'), zaehlerText(zaehler[key] || 0));
    });

    var gefiltert = suchwoerter.length > 0 || thema !== 'alle';
    setzeText(wurzel.querySelector('[data-mv-faq-status]'), statusText(sichtbar.length, suchwoerter.length > 0, themaTitel(wurzel, thema)));
    var leer = wurzel.querySelector('[data-mv-faq-leer]');
    if (leer) leer.hidden = !(gefiltert && sichtbar.length === 0);
    var leeren = wurzel.querySelector('[data-mv-faq-leeren]');
    if (leeren) leeren.hidden = !(feld && feld.value);
    alleLinks(wurzel, feld ? feld.value : '');
    if (suchwoerter.length && sichtbar.length === 1) sichtbar[0].open = true;
  }

  function planen(wurzel, aktion) {
    var alt = zeitgeber ? zeitgeber.get(wurzel) : wurzel.__mvFaqZeit;
    if (alt) window.clearTimeout(alt);
    var neu = window.setTimeout(function () {
      if (zeitgeber) zeitgeber.delete(wurzel);
      else wurzel.__mvFaqZeit = 0;
      (aktion || anwenden)(wurzel);
    }, VERZOEGERUNG);
    if (zeitgeber) zeitgeber.set(wurzel, neu);
    else wurzel.__mvFaqZeit = neu;
  }

  function setzeThema(wurzel, thema) {
    wurzel.setAttribute('data-mv-faq-thema', thema || 'alle');
    anwenden(wurzel);
  }

  function zuruecksetzen(wurzel) {
    var feld = feldVon(wurzel);
    if (feld) feld.value = '';
    setzeThema(wurzel, 'alle');
  }

  // Anker #faq-<kennung> (nur innerhalb einer FAQ-Sektion): verborgenes Ziel freilegen und hinscrollen,
  // eine Frage aufklappen. Gruppen: faq-multi-groups und mv-faq; Fragen: #faq-<key>-<n> bzw. #faq-<frage>.
  function oeffneAusHash() {
    var id = zielAusHash(window.location.hash);
    if (!id) return;
    var ziel = document.getElementById(id);
    if (!ziel || !ziel.matches) return;
    var istFrage = ziel.matches('[data-mv-faq-eintrag]');
    if (!istFrage && !ziel.matches('[data-mv-faq-gruppe]')) return;
    var wurzel = wurzelVon(ziel);
    if (!wurzel) return;
    var verborgen = ziel.hidden || (istFrage && ziel.closest('[data-mv-faq-gruppe]') && ziel.closest('[data-mv-faq-gruppe]').hidden);
    if (verborgen) zuruecksetzen(wurzel);
    if (istFrage) ziel.open = true;
    if (verborgen && typeof ziel.scrollIntoView === 'function') ziel.scrollIntoView();
  }

  // ---------------------------------------------------------------------------------------------
  // Uebersicht (Modus hub)
  // ---------------------------------------------------------------------------------------------

  function hubVon(el) {
    return el && el.closest ? el.closest('[data-mv-faq-hub]') : null;
  }

  function hubZustand(hub) {
    var z = hubZustaende ? hubZustaende.get(hub) : hub.__mvFaqHub;
    if (!z) {
      z = { daten: null, alle: false, einzeln: '' };
      if (hubZustaende) hubZustaende.set(hub, z);
      else hub.__mvFaqHub = z;
    }
    return z;
  }

  // Daten aus dem template: Themen mit Ziel (veroeffentlichte Themenseite) und alle Fragen mit Suchtext
  function hubDaten(hub) {
    var z = hubZustand(hub);
    if (z.daten) return z.daten;
    var d = { eintraege: [], karte: { fragen: {}, ziele: {} } };
    var vorlage = hub.querySelector('template[data-mv-faq-hub-daten]');
    var quelle = vorlage ? (vorlage.content || vorlage) : null;
    if (quelle && quelle.querySelectorAll) {
      alle(quelle, '[data-mv-faq-hub-thema]').forEach(function (t) {
        var g = t.getAttribute('data-mv-faq-hub-thema');
        var ziel = t.getAttribute('data-mv-faq-hub-ziel');
        if (g && ziel) d.karte.ziele[g] = ziel;
      });
      alle(quelle, '[data-mv-faq-hub-eintrag]').forEach(function (el) {
        var id = el.getAttribute('data-mv-faq-hub-eintrag');
        var frage = el.querySelector('[data-mv-faq-hub-text]');
        var kopf = el.querySelector('summary');
        var antwort = el.querySelector('[data-mv-faq-hub-antwort]');
        d.karte.fragen[id] = el.getAttribute('data-mv-faq-hub-gruppe') || '';
        d.eintraege.push({
          id: id,
          frage: frage ? frage.textContent : '',
          heu: normalisiere((kopf ? kopf.textContent : '') + ' ' + (antwort ? antwort.textContent : '')),
          el: el
        });
      });
    }
    z.daten = d;
    return d;
  }

  // Frage im Treffer: Suchwoerter als mark (Text bleibt unveraendert, nur Textknoten und mark)
  function markieren(el, teile) {
    while (el.firstChild) el.removeChild(el.firstChild);
    for (var i = 0; i < teile.length; i++) {
      if (teile[i][1]) {
        var m = document.createElement('mark');
        m.className = 'mv-faqhub__mark';
        m.textContent = teile[i][0];
        el.appendChild(m);
      } else {
        el.appendChild(document.createTextNode(teile[i][0]));
      }
    }
  }

  function hubAnwenden(hub) {
    var z = hubZustand(hub);
    var d = hubDaten(hub);
    var feld = hub.querySelector('[data-mv-faq-hub-suche]');
    var eingabe = feld ? feld.value : '';
    var aktiv = istSuche(eingabe);
    var treffer = [];
    var einzeln = false;
    if (aktiv) {
      z.einzeln = '';
      treffer = sucheFragen(d.eintraege, eingabe);
    } else if (z.einzeln) {
      treffer = d.eintraege.filter(function (e) { return e.id === z.einzeln; });
      einzeln = treffer.length > 0;
    }
    var zeigen = aktiv || einzeln;
    var anzahl = z.alle ? treffer.length : Math.min(treffer.length, GRENZE);
    var w = woerter(eingabe);

    var liste = hub.querySelector('[data-mv-faq-hub-liste]');
    if (liste) {
      while (liste.firstChild) liste.removeChild(liste.firstChild);
      for (var i = 0; i < anzahl; i++) {
        var knoten = document.importNode(treffer[i].el, true);
        var text = knoten.querySelector('[data-mv-faq-hub-text]');
        if (text && aktiv) markieren(text, abschnitte(treffer[i].frage, w));
        if (treffer.length === 1) knoten.open = true;
        liste.appendChild(knoten);
      }
      liste.hidden = anzahl === 0;
    }
    var bereich = hub.querySelector('[data-mv-faq-hub-treffer]');
    if (bereich) bereich.hidden = !zeigen;
    alle(hub, '[data-mv-faq-hub-start]').forEach(function (el) { el.hidden = zeigen; });
    var mehr = hub.querySelector('[data-mv-faq-hub-mehr]');
    if (mehr) {
      mehr.hidden = !(zeigen && treffer.length > anzahl);
      setzeText(mehr, TEXT.mehr.replace('{n}', String(treffer.length)));
    }
    var leer = hub.querySelector('[data-mv-faq-hub-leer]');
    if (leer) leer.hidden = !(aktiv && treffer.length === 0);
    var leeren = hub.querySelector('[data-mv-faq-hub-leeren]');
    if (leeren) leeren.hidden = !(feld && feld.value);
    setzeText(hub.querySelector('[data-mv-faq-hub-status]'), einzeln ? TEXT.einzeln : hubStatusText(treffer.length, aktiv));
  }

  // Alter Anker: Weiterleitung auf die veroeffentlichte Themenseite, sonst die Frage als einzelner Treffer
  function hubAusHash(hub) {
    var d = hubDaten(hub);
    var ziel = zielFuerHash(window.location.hash, d.karte);
    if (ziel) {
      hub.setAttribute('data-mv-faq-hub-weiter', ziel);
      try { window.location.replace(ziel); } catch (e) { /* Umgebung ohne Navigation */ }
      return true;
    }
    var id = zielAusHash(window.location.hash);
    var kennung = id ? id.slice(4) : '';
    if (kennung && hat(d.karte.fragen, kennung)) {
      var z = hubZustand(hub);
      var feld = hub.querySelector('[data-mv-faq-hub-suche]');
      if (feld) feld.value = '';
      z.einzeln = kennung;
      z.alle = false;
      hubAnwenden(hub);
      var bereich = hub.querySelector('[data-mv-faq-hub-treffer]');
      if (bereich && typeof bereich.scrollIntoView === 'function') bereich.scrollIntoView();
    }
    return false;
  }

  function hubLeeren(hub, fokus) {
    var z = hubZustand(hub);
    var feld = hub.querySelector('[data-mv-faq-hub-suche]');
    if (feld) feld.value = '';
    z.einzeln = '';
    z.alle = false;
    hubAnwenden(hub);
    if (fokus && feld) feld.focus();
  }

  function hubStarten(hub) {
    alle(hub, '[data-mv-faq-hub-suche-box]').forEach(function (el) { el.hidden = false; });
    hub.setAttribute('data-mv-faq-hub-bereit', VERSION);
    if (hubAusHash(hub)) return;
    var feld = hub.querySelector('[data-mv-faq-hub-suche]');
    var q = qAusSuche(window.location.search);
    if (q && feld && !feld.value) feld.value = q;
    hubAnwenden(hub);
  }

  // Wischbare Themen-Reihe: aktuelles Thema in den sichtbaren Bereich rollen, ohne die Seite zu bewegen
  function themenRollen(wurzel) {
    alle(wurzel, '[data-mv-faq-themen]').forEach(function (reihe) {
      var aktiv = reihe.querySelector('[aria-current="page"]');
      if (!aktiv || reihe.scrollWidth <= reihe.clientWidth) return;
      var links = aktiv.getBoundingClientRect().left - reihe.getBoundingClientRect().left + reihe.scrollLeft;
      reihe.scrollLeft = Math.max(0, links - (reihe.clientWidth - aktiv.offsetWidth) / 2);
    });
  }

  function starten(bereich) {
    var wurzeln = [];
    if (bereich && bereich.matches && bereich.matches('[data-mv-faq]')) wurzeln.push(bereich);
    if (bereich && bereich.querySelectorAll) wurzeln = wurzeln.concat(alle(bereich, '[data-mv-faq]'));
    wurzeln.forEach(function (wurzel) {
      alle(wurzel, '[data-mv-faq-suche-box]').forEach(function (box) { box.hidden = false; });
      if (!wurzel.getAttribute('data-mv-faq-thema')) wurzel.setAttribute('data-mv-faq-thema', 'alle');
      wurzel.setAttribute('data-mv-faq-bereit', VERSION);
      anwenden(wurzel);
      themenRollen(wurzel);
    });
    var hubs = [];
    if (bereich && bereich.matches && bereich.matches('[data-mv-faq-hub]')) hubs.push(bereich);
    if (bereich && bereich.querySelectorAll) hubs = hubs.concat(alle(bereich, '[data-mv-faq-hub]'));
    hubs.forEach(hubStarten);
  }

  document.addEventListener('input', function (e) {
    var feld = e.target;
    if (!feld || !feld.matches) return;
    if (feld.matches('[data-mv-faq-hub-suche]')) {
      var hub = hubVon(feld);
      if (hub) {
        hubZustand(hub).alle = false;
        planen(hub, hubAnwenden);
      }
      return;
    }
    if (!feld.matches('[data-mv-faq-suche]')) return;
    var wurzel = wurzelVon(feld);
    if (!wurzel) return;
    alleLinks(wurzel, feld.value);
    planen(wurzel, anwenden);
  });

  document.addEventListener('keydown', function (e) {
    var feld = e.target;
    if (e.key !== 'Escape' || !feld || !feld.matches || !feld.value) return;
    if (feld.matches('[data-mv-faq-hub-suche]')) {
      var hub = hubVon(feld);
      if (!hub) return;
      e.preventDefault();
      hubLeeren(hub, false);
      return;
    }
    if (!feld.matches('[data-mv-faq-suche]')) return;
    e.preventDefault();
    feld.value = '';
    var wurzel = wurzelVon(feld);
    if (wurzel) anwenden(wurzel);
  });

  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;

    var hub = hubVon(ziel);
    if (hub) {
      var begriff = ziel.closest('[data-mv-faq-hub-begriff]');
      var hubFeld = hub.querySelector('[data-mv-faq-hub-suche]');
      if (begriff) {
        if (hubFeld) hubFeld.value = begriff.getAttribute('data-mv-faq-hub-begriff') || '';
        hubZustand(hub).alle = false;
        hubAnwenden(hub);
        return;
      }
      if (ziel.closest('[data-mv-faq-hub-leeren]') || ziel.closest('[data-mv-faq-hub-zuruecksetzen]')) {
        hubLeeren(hub, true);
        return;
      }
      if (ziel.closest('[data-mv-faq-hub-mehr]')) {
        hubZustand(hub).alle = true;
        hubAnwenden(hub);
        var liste = hub.querySelector('[data-mv-faq-hub-liste]');
        var naechster = liste && liste.children[GRENZE] ? liste.children[GRENZE].querySelector('summary') : null;
        if (naechster) naechster.focus();
      }
      return;
    }

    var wurzel = wurzelVon(ziel);
    if (!wurzel) return;

    var chip = ziel.closest('[data-mv-faq-chip]');
    if (chip) {
      e.preventDefault();
      setzeThema(wurzel, chip.getAttribute('data-mv-faq-chip'));
      return;
    }
    if (ziel.closest('[data-mv-faq-leeren]')) {
      var feld = feldVon(wurzel);
      if (feld) {
        feld.value = '';
        feld.focus();
      }
      anwenden(wurzel);
      return;
    }
    if (ziel.closest('[data-mv-faq-zuruecksetzen]')) {
      zuruecksetzen(wurzel);
      var suche = feldVon(wurzel);
      if (suche) suche.focus();
    }
  });

  window.addEventListener('hashchange', function () {
    oeffneAusHash();
    alle(document, '[data-mv-faq-hub]').forEach(hubAusHash);
  });

  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var eintrag = e.target && e.target.closest ? e.target.closest('[data-mv-faq-eintrag]') : null;
    var wurzel = wurzelVon(eintrag);
    if (!eintrag || !wurzel) return;
    if (eintrag.hidden) zuruecksetzen(wurzel);
    eintrag.open = true;
  });

  function bereit() {
    starten(document);
    oeffneAusHash();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bereit);
  else bereit();
})();
